import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, priority, ...props }, index) {
        return (
          <Toast 
            key={id} 
            {...props}
            className={`
              ${props.className || ''}
              ${priority === 3 ? 'border-l-4 border-l-yellow-500 bg-yellow-50 dark:bg-yellow-900/20' : ''}
              ${priority === 2 ? 'border-l-4 border-l-primary bg-primary/5 dark:bg-primary/10' : ''}
              transform transition-all duration-200 ease-in-out
            `.trim()}
            style={{
              ...props.style,
              transform: `translateY(${index * 4}px) scale(${1 - index * 0.02})`,
              zIndex: 1000 - index,
            }}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
